import { render, staticRenderFns } from "./TemplateFieldEditor.vue?vue&type=template&id=1b396989&scoped=true"
import script from "./TemplateFieldEditor.vue?vue&type=script&lang=js"
export * from "./TemplateFieldEditor.vue?vue&type=script&lang=js"
import style0 from "./TemplateFieldEditor.vue?vue&type=style&index=0&id=1b396989&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b396989",
  null
  
)

export default component.exports